// extracted by css-extract-rspack-plugin
export default {"container":"_5cff9800","swatchCircle":"_f2eedaf","swatchesCount":"_30f63328","link":"_1c82ae87"};